// extracted by mini-css-extract-plugin
module.exports = {"PodSmallRegularLayout":"Examples_PodSmallRegularLayout__1JRVu","PodSmallRegularBox":"Examples_PodSmallRegularBox__34arY"};